// src/components/helpers/FormCheckbox.js
import React, { memo } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormHelperText from "@mui/material/FormHelperText";

function FormCheckbox({
  label,
  checked,
  onChange,
  name,
  displaySide,
  color = "primary",
  isReadOnly = false,
  status,
  helperText,
}) {
  const getLabelColor = () => {
    switch (status) {
      case "error":
        return "#f44336";
      case "warning":
        return "#ffd500";
      case "success":
        return "#4caf50";
      default:
        return "";
    }
  };

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center" }}>
        {displaySide === "left" && (
          <span style={{ marginRight: 20, color: getLabelColor() }}>
            {label}
          </span>
        )}
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={onChange}
              name={name}
              color="primary"
              disabled={isReadOnly}
            />
          }
          label={
            displaySide !== "left" && (
              <span style={{ marginLeft: 10, color: getLabelColor() }}>
                {label}
              </span>
            )
          }
        />
      </div>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </div>
  );
}

export default memo(FormCheckbox);
